/* prettier-ignore */

import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import OSRMTextInstructions from 'osrm-text-instructions';

@Component({
    imports: [
        CommonModule,
        FormsModule
    ],
    standalone: true,
    templateUrl: './testing-route.component.html',
    styleUrls: ['./testing-route.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class TestingRouteComponent {
    private http = inject(HttpClient);
    public coords: string;
    private routes: any = []
    polylines: any;
    instructions: any

    sendForm(){
        this.getRouteGeometry().subscribe(res => {
            this.polylines = res;
            console.log("POLYLINES API RESPONSE: ", res)
        })
    }

    getRouteGeometry(): Observable<any> {
        const url = `https://cms-iurban.com/osrm_foot/route/v1/driving/${this.coords}?steps=true&overview=full`;
        return this.http.get<any>(url).pipe(
            tap(res => {
                this.routes = res.routes[0];
            }),
            map(res => res.routes[0].geometry),
            map(geo => this.polylineDecode(geo, 5)),
            catchError(err => {
                console.error('Error fetching route geometry', err);
                return throwError(() => new Error('HTTP request failed', { cause: err }));
            })
        );
    }

    getRouteInfo(){
        const version = 'v5';
        const osrmTextInstructions = OSRMTextInstructions(version);
        console.log("ROUTES 1: ", structuredClone(this.routes));
        
        
        this.instructions = this.routes?.legs?.map((item, index) => {
            item.steps = item.steps.map(step => {
                const instruction = osrmTextInstructions.compile('es', step, {});
                return {
                    instruction,
                    distance: step.distance,
                    duration: step.duration,
                    location: {lat: step.maneuver.location?.[1], lng: step.maneuver.location?.[0]},
                    mode: step.mode
                }
            });
            return {
                distance: item.distance,
                duration: item.duration,
                transfers: item.steps
            };
        })?.[0];

        console.log("ROUTES 2: ", structuredClone(this.instructions));

    }

    polylineDecode(str: string, prec = 6): google.maps.LatLngLiteral[] {
        let index = 0, lat = 0, lng = 0, shift = 0, result = 0, byte = 0;
        const coords: google.maps.LatLngLiteral[] = [];
        const factor = Math.pow(10, prec);
        while (index < str.length) {
        shift = result = 0;
        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);
        const dlat = (result & 1) ? ~(result >> 1) : (result >> 1);

        shift = result = 0;
        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);
        const dlng = (result & 1) ? ~(result >> 1) : (result >> 1);

        lat += dlat; lng += dlng;
        coords.push({ lat: lat / factor, lng: lng / factor });
        }
        return coords;
    }

}